import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { InputProps } from 'antd';
import { AsYouType } from 'libphonenumber-js';
import LtrInput from './LtrInput';

export function applyMask<V = InputProps['value']>(value: V): V | string {
  if (typeof value !== 'string') return value;
  const appendedPlusValue = value ? `+${value.replace('+', '')}` : '';
  const maskedValue = new AsYouType().input(appendedPlusValue);
  return maskedValue;
}

const PhoneNumberInput: FC<InputProps | any> = (props) => {
  const { value, setShowErr, ...rest } = props;

  return (
    <LtrInput
      onBlur={() => {
        setShowErr(true);
      }}
      onBlurCapture={() => {
        setShowErr(true);
      }}
      onFocus={() => {
        setShowErr(false);
      }}
      value={applyMask(value)?.replace(/\s/g, '') || ''}
      {...rest}
    />
  );
};

export default PhoneNumberInput;
